var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 0.999999 5.47715 0.999999 11C0.999999 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11ZM9.66657 7.39046L6.05709 10.9999L9.66657 14.6094L10.6094 13.6666L8.60944 11.6667H15.6667V10.3333H8.60931L10.6094 8.33327L9.66657 7.39046Z",
    stroke: "#011C14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.41b6f93bf4b8f72069aa3a0928f61eeb.svg";
export { ForwardRef as ReactComponent };